"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const moment = require("moment-timezone");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../components/MobilePopover");
class TimezonePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            selectedTimezone: moment.tz.guess(),
            timezoneSearch: '',
        };
        this.cancelUpdateTimezone = this.cancelUpdateTimezone.bind(this);
        this.updatePopoverVisibility = this.updatePopoverVisibility.bind(this);
        this.updateTimezone = this.updateTimezone.bind(this);
    }
    cancelUpdateTimezone() {
        const { dateTime } = this.props;
        const timeZone = dateTime ? dateTime.timeZone : null;
        this.setState({
            selectedTimezone: timeZone || moment.tz.guess(),
        });
        this.updatePopoverVisibility();
    }
    getDisplayNames() {
        const { timezoneSearch } = this.state;
        return moment.tz
            .names()
            .filter((name) => name.toLowerCase().includes(timezoneSearch.toLowerCase()) || timezoneSearch === '');
    }
    updatePopoverVisibility() {
        const { activePopover, closePopoverModalForm, device, updateActivePopover } = this.props;
        if (activePopover === 'scheduled-timezone-picker') {
            closePopoverModalForm();
            setTimeout(() => {
                this.setState({ timezoneSearch: '' });
                updateActivePopover('');
            }, device === 'Mobile' ? 500 : 0);
            return;
        }
        updateActivePopover('scheduled-timezone-picker');
    }
    updateTimezone() {
        const { dateTime, updateScheduledCampaignTrigger } = this.props;
        const { selectedTimezone } = this.state;
        updateScheduledCampaignTrigger({
            dateTime: Object.assign(Object.assign({}, dateTime), { timeZone: selectedTimezone }),
        });
        this.updatePopoverVisibility();
    }
    renderCurrentTimezone() {
        const { dateTime } = this.props;
        const timeZone = dateTime ? dateTime.timeZone : null;
        return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
            React.createElement(src_1.Text, { text: "Time zone", label: true, size: "small" }),
            React.createElement(src_1.Text, { text: timeZone || moment.tz.guess(), size: "large", textStyle: { color: src_1.charcoal } })));
    }
    renderTimezones() {
        const { device } = this.props;
        const { selectedTimezone } = this.state;
        const displayNames = this.getDisplayNames();
        return (React.createElement(src_1.SelectableList, { device: device }, displayNames.map((name) => (React.createElement("div", { key: name, onClick: (e) => {
                e.stopPropagation();
                this.setState({
                    selectedTimezone: name,
                });
            }, style: {
                display: 'flex',
                height: device !== 'Mobile' ? 55 : 71,
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(src_1.Text, { text: name, size: "large" }),
            React.createElement(src_1.RadioButton, { selected: selectedTimezone === name, style: {
                    outerStyle: { height: 18, width: 18 },
                } }))))));
    }
    render() {
        const { activePopover, device, dateTime, isPopoverModalFormOpen } = this.props;
        const { isSearchFocused, timezoneSearch } = this.state;
        return device !== 'Mobile' ? (React.createElement("div", { style: {
                height: 96,
                width: '100%',
                borderBottom: `1px solid ${src_1.titanium}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }, onClick: this.updatePopoverVisibility },
            this.renderCurrentTimezone(),
            React.createElement(src_1.PopoverContainer, { id: "timezone-picker-popover", popoverProps: {
                    placement: 'left',
                    device: device,
                    navBarProperties: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelUpdateTimezone,
                        buttonRight: 'Done',
                        buttonRightCallback: this.updateTimezone,
                    },
                }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: this.updatePopoverVisibility, showPopover: activePopover === 'scheduled-timezone-picker' },
                device === 'Desktop' ? (React.createElement(src_1.Button, { text: "Change", type: "regular", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "timezone-selector" })) : (React.createElement(src_1.ChangeIcon, { fill: src_1.titanium })),
                React.createElement("div", { style: {
                        width: 384,
                        height: 296,
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (timezoneSearch) => this.setState({ timezoneSearch }), text: timezoneSearch }),
                    React.createElement("div", { style: { flex: '1 1 auto', overflowY: 'scroll' } }, this.renderTimezones()))))) : (React.createElement("div", { style: {
                height: 96,
                width: '100%',
                borderBottom: `1px solid ${src_1.titanium}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            }, onClick: this.updatePopoverVisibility },
            this.renderCurrentTimezone(),
            activePopover === 'scheduled-timezone-picker' &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelUpdateTimezone,
                        buttonRight: 'Done',
                        buttonRightCallback: this.updateTimezone,
                    } },
                    React.createElement("div", { style: {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        } },
                        React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({
                                isSearchFocused: false,
                            }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (timezoneSearch) => this.setState({ timezoneSearch }), text: timezoneSearch }),
                        React.createElement("div", { style: {
                                flex: '1 1 auto',
                                overflowY: 'scroll',
                            } }, this.renderTimezones()))), document.getElementById('mainModalLeft'))));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    dateTime: reducers_1.getEditableCampaignScheduledCampaignTrigger(state).dateTime,
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        updateScheduledCampaignTrigger: (t) => dispatch(actions_1.updateScheduledCampaignTrigger(t)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TimezonePicker);
